export default __webpack_public_path__ + "static/geography-img-1-514b9360363209924614b468b4f79f49.jpg";